import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import {
  POST_PAYMENTS_PREFERENCES_URL,
  POST_PARENTING_SCHEDULE_PREFERENCES_URL,
  GET_PREFERENCES_URL
} from '@/constants/ApiConstants'

const state = {}

const getters = {}

const actions = {
  [action.POST_PAYMENTS_PREFERENCES]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
      .post(POST_PAYMENTS_PREFERENCES_URL, data)
      .then((response) => {
        return resolve(response)
      })
      .catch(error => {
        return reject(error)
      })
    })
  },
  [action.POST_PARENTING_SCHEDULE_PREFERENCES]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
      .post(POST_PARENTING_SCHEDULE_PREFERENCES_URL, data)
      .then((response) => {
        return resolve(response)
      })
      .catch(error => {
        return reject(error)
      })
    })
  },
  [action.GET_PREFERENCES]({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService
      .get(GET_PREFERENCES_URL)
      .then((response) => {
        return resolve(response)
      })
      .catch(error => {
        return reject(error)
      })
    })
  },
}

export default {
  state,
  actions,
  getters
}
